// @flow
import React, { useState } from 'react';
import {
  supportsGeolocation,
  getGeolocation as getGeolocationHelper
} from '../../../helpers/geolocation';
import {
  geolocationToLatLng as geolocationToLatLngHelper,
  geocodeLatLng as geocodeLatLngHelper
} from '../../../helpers/maps';

import '../../../../static/scss/components/geolocationButton.scss';

type Props = {
  onAddressFound: (...args: Array<any>) => any,
  hasGeolocation?: boolean,
  getGeolocation?: (...args: Array<any>) => any,
  geolocationToLatLng?: (...args: Array<any>) => any,
  geocodeLatLng?: (...args: Array<any>) => any
};

const GeolocationButton = ({
  onAddressFound,
  hasGeolocation = supportsGeolocation,
  geocodeLatLng = geocodeLatLngHelper,
  geolocationToLatLng = geolocationToLatLngHelper,
  getGeolocation = getGeolocationHelper
}: Props) => {
  const [loading, setLoading] = useState(false);
  const [hasResult, setHasResult] = useState(false);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);

  const baseClassName = 'c-predictive-search-input__geolocation-button';
  const loadingClass = loading ? ` ${baseClassName}--is-loading` : '';

  const onClick = () => {
    setLoading(true);

    // Allow cached cached locations 120000 is 2 mins.
    getGeolocation({ maximumAge: 120000 })
      .then(geolocationToLatLng)
      .then(geocodeLatLng)
      .then(geocoderResult => {
        const newLat = geocoderResult[0].geometry.location.lat();
        const newLng = geocoderResult[0].geometry.location.lng();
        const address = geocoderResult[0].formatted_address;
        onAddressFound(address, { lat: newLat, lng: newLng });

        setLoading(false);
        setHasResult(true);
        setLat(newLat);
        setLng(newLng);
      })
      .catch(() => {
        setLoading(false);
        setHasResult(false);
      });
  };

  return (
    <div className={`${baseClassName}-container`}>
      {hasGeolocation && (
        <button
          type="button"
          className={`${baseClassName}${loadingClass} c-focus-geolocation__button hide-text`}
          onClick={onClick}
        >
          Use my current location.
        </button>
      )}
      {hasResult && (
        <input type="hidden" name="coords" value={`${lat},${lng}`} />
      )}
    </div>
  );
};

export default GeolocationButton;
